import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IState {
  [key: string]: any;
  // page: number;
}

const initialState: IState = {};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setAppData: (state, action: PayloadAction<any>) => {
      return { ...state, ...action.payload };
    },
    // changePage: (state, action: PayloadAction<number>) => {
    //   return { ...state, page: action.payload };
    // },
  },
});

export const { setAppData } = appSlice.actions;

export default appSlice.reducer;
